import { defineComponent as p, defineAsyncComponent as m, ref as r } from "vue";
import "../../../base_application/ui/components/index2.js";
import "../../../base_application/ui/components/index3.js";
import "../../../base_application/ui/components/index4.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import { signOutUser as s } from "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import "../../../search/ui/components/available_contracts/index2.js";
import "@ado/translation-library";
import "../../../sign_in/ui/components/index2.js";
const a = 401, d = "unhandledrejection", I = p({
  name: "ExpiredSessionDialogWrapper",
  components: {
    ExpiredSessionDialog: m(
      () => import("./index3.js")
    )
  },
  setup() {
    const o = r(!1), t = r(!1), e = function(n) {
      const { reason: i } = n;
      i !== void 0 && i.status === a && (s(), t.value = !0, o.value = !0);
    };
    return window.addEventListener(
      d,
      e
    ), {
      loadDialog: t,
      showDialog: o
    };
  }
});
export {
  I as default
};
//# sourceMappingURL=index2.js.map
